import { Component, inject, Input } from '@angular/core';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DomainService } from 'services/domain.service';
import { CompanySearchComponent } from 'components/core/company-search/company-search.component';
import { CompanyService } from 'services/company.service';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'change-domain-owner',
	templateUrl: './change-domain-owner.component.html',
	imports: [Layout, CompanySearchComponent, TranslatePipe]
})
export class ChangeDomainOwnerComponent {

	@Input() domainId?: string;
	selectedCompanyId?: string;
	currentOwner?: CompanyModel;
	selectedCompanyInfo?: CompanyModel;

	private readonly navigationService = inject(NavigationService);
	private readonly domainService = inject(DomainService);
	private readonly companyService = inject(CompanyService);

	async selectCompany(companyId: string) {
		this.selectedCompanyId = companyId;
		this.selectedCompanyInfo = undefined;
		this.selectedCompanyInfo = await this.companyService.getCompany(companyId);
	}

	async changeOwner() {
		if (!this.domainId || !this.selectedCompanyInfo || !this.currentOwner || !this.selectedCompanyId) return;
		await this.domainService.moveDomainToCompany(this.domainId, this.selectedCompanyId, this.currentOwner.vatNumber);
		this.navigationService.closeView(this);
	}

}
